<template>
  <Modal
    name="REMOVE_APPOINTMENT_FROM_GROUP_MODAL"
    :title="$t('mapDrawing.removeAppointmentFromGroupModal.title')"
    ref="removeAppointmentFromGroupModal"
    actions
  >
    <template v-slot:body>
      <v-row no-gutters>
        <v-col cols="12" sm="9">
          <h6 class="text-uppercase grey--text">
            {{ $t('mapDrawing.removeAppointmentFromGroupModal.type') }}
          </h6>
          <p class="body-2 mb-3">
            {{ $t(`appointment.type.${title}`) }}
          </p>
        </v-col>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mapDrawing.removeAppointmentFromGroupModal.status') }}
          </h6>
          <p class="body-2 mb-3">
            {{ $t(`appointment.status.${status}`) }}
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col cols="12" sm="9">
          <h6 class="text-uppercase grey--text">
            {{ $t('mapDrawing.removeAppointmentFromGroupModal.realEstate') }}
          </h6>
          <p class="body-2 mb-3">
            {{ realEstate }}
          </p>
        </v-col>
        <v-col>
          <h6 class="text-uppercase grey--text">
            {{ $t('mapDrawing.removeAppointmentFromGroupModal.code') }}
          </h6>
          <p class="body-2 mb-3">
            {{ code }}
          </p>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <div class="mt-2 d-flex align-center">
          <HCheckbox
            class="mr-2"
            v-model="notifyPropertyManager"
            :label="$t('appointment.cancelModal.notifyPropertyManager')"
          />
          <InformationTooltip :message="$t('appointment.cancelModal.notifyPropertyManagerInfoMessage')" />
        </div>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeModal('REMOVE_APPOINTMENT_FROM_GROUP_MODAL')"
        :disabled="isLoading"
        elevation="0"
        color="grey"
        large
        text
      >
        {{ $t('mapDrawing.removeAppointmentFromGroupModal.cancel') }}
      </v-btn>
      <v-btn
        @click="removeAppointmentFromGroup(appointment.id)"
        :loading="isLoading"
        color="primary"
        elevation="0"
        class="ml-5"
        large
        dark
      >
        {{ $t('mapDrawing.removeAppointmentFromGroupModal.remove') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Modal from '@/components/app/Modal'
import { code } from '../../../util/errorHandling'
import HCheckbox from '../../app/HCheckbox.vue'
import InformationTooltip from '../../app/InformationTooltip.vue'

export default {
  name: 'ModalAppointmentRemoveFromGroup',

  components: {
    Modal,
    HCheckbox,
    InformationTooltip,
  },

  props: {
    groupId: {
      type: String,
      required: false,
    },

    appointment: {
      type: Object,
      required: false,
    },
  },

  data() {
    return {
      notifyPropertyManager: false
    }
  },

  computed: {
    ...mapGetters(['isLoading']),

    code() {
      return this.appointment?.code
    },

    title() {
      return this.appointment?.title ?? this.appointment?.type
    },

    status() {
      return this.appointment?.status
    },

    realEstate() {
      return this.appointment?.real_estate?.name
    }
  },

  methods: {
    ...mapActions(['closeModal', 'partnerRemoveAppointmentFromGroup']),

    createPayload() {
      return {
        appointments: [this.appointment.id],
        groupId: this.groupId,
        notifyPropertyManager: this.notifyPropertyManager
      }
    },

    removeAppointmentFromGroup() {
      this.partnerRemoveAppointmentFromGroup(this.createPayload())
        .then(() => { if (this.$parent?.refreshMap) this.$parent?.refreshMap() })
        .then(() => this.closeModal('REMOVE_APPOINTMENT_FROM_GROUP_MODAL'))
    }
  }
}
</script>
